<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'KALDIK'">
          <template v-slot:toolbar>
          </template>
          <template v-slot:body>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="64">
                  <v-toolbar flat>
                    <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                      Today
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="prev">
                      <v-icon small>
                        mdi-chevron-left
                      </v-icon>
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="next">
                      <v-icon small>
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                    <v-toolbar-title>
                      {{ month }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                          <span>{{ typeToLabel[type] }}</span>
                          <v-icon right>
                            mdi-menu-down
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="type = 'day'">
                          <v-list-item-title>Day</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'week'">
                          <v-list-item-title>Week</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'month'">
                          <v-list-item-title>Month</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="type = '4day'">
                              <v-list-item-title>4 days</v-list-item-title>
                            </v-list-item> -->
                      </v-list>
                    </v-menu>
                  </v-toolbar>
                </v-sheet>
                <v-sheet height="600">
                  <!-- <v-calendar ref="calendar2" v-model="focus" color="primary" :events="events" :event-color="getEventColor"
                  :type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay"
                    @change="updateRange"></v-calendar> -->
                  <v-calendar ref="calendar2" v-model="focus" color="primary" :events="events"
                    :event-color="getEventColor" :now="today" :type="type" @click:event="showEvent" @click:more="viewDay"
                    @click:date="viewDay" @change="updateRange"></v-calendar>
                  <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
                    <v-card color="grey lighten-4" min-width="350px" flat>
                      <v-toolbar :color="selectedEvent.color" dark>
                        <v-btn icon>
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>mdi-heart</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <span v-html="selectedEvent.details"></span>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text color="secondary" @click="selectedOpen = false">
                          Cancel
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-sheet>
              </v-col>
            </v-row>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex"
import KTCodePreview from "@/view/content/CardContent.vue";
import axios from "axios"

export default {
  name: 'jadwal',
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    tgl_hari_ini() {
      return this.$route.params != null ? this.$route.params.item : null
    }, 
  },
  data() {
    return {
      today: new Date(this.$route.params.date),
      month: new Date(this.$route.params.date).toLocaleString('default', { month: 'long' }) + ' ' + new Date(this.$route.params.date).getFullYear(),
      focus: new Date(this.$route.params.date),
      type: "month",
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      // '4day': '4 Days',
    },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Jadwal" }
    ]);

    // set subheader not display
    this.config.subheader.display = true
    
  },
  components: {
    KTCodePreview
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
      this.month= new Date(this.$route.params.date).toLocaleString('default', { month: 'long' }) + ' ' + new Date(this.$route.params.date).getFullYear()
    },
    prev() {
      this.$refs.calendar2.prev();
      this.month= new Date(this.focus).toLocaleString('default', { month: 'long' }) + ' ' + new Date(this.focus).getFullYear()
    },
    next() {
      this.$refs.calendar2.next();
      this.month= new Date(this.focus).toLocaleString('default', { month: 'long' }) + ' ' + new Date(this.focus).getFullYear()
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async updateRange({ start, end }) {
      const events = [];
      
      await axios.get('master/academic-calender')
      .then(response => {
          if (response.status == 200) {
            response.data.data.some((e, index) => {
              
              let newDateStart = e.tgl_mulai.split("-").reverse().join("-")
              newDateStart = new Date(e.tgl_mulai).getFullYear() + "-" +  (new Date(e.tgl_mulai).getMonth() + 1) + "-" + new Date(e.tgl_mulai).getDate()

              let newDateEnd = e.tgl_akhir.split("-").reverse().join("-")
              newDateEnd = new Date(e.tgl_akhir).getFullYear() + "-" + (new Date(e.tgl_akhir).getMonth() + 1) + "-" + new Date(e.tgl_akhir).getDate() 

              events.push({
                name: e.detail,
                start: newDateStart,
                end: newDateEnd,
                color: "#" + e.kode_warna
              });
              return index > e.length;
            });
          }
        })
    
      this.start = start;
      this.end = end;
      this.events = events;

    },

  }
}
</script>
<style>
.btn-cal {
  border: 1px solid gray !important;
}
.theme--light.v-calendar-daily{
  border-left: 0px !important;
}
.v-calendar-daily__head{
  border-left: #e0e0e0 1px solid !important;
}
.v-calendar-daily__body {
  display: none !important;
}
</style>